import { render } from "./BookingCsvImport.vue?vue&type=template&id=7ffbe374"
import script from "./BookingCsvImport.vue?vue&type=script&lang=js"
export * from "./BookingCsvImport.vue?vue&type=script&lang=js"
script.render = render

export default script